const PATH = 'fe.components.calibrations.rewatch_video_accordion';

const messages = {
  header: {
    key: `${PATH}.header`,
    defaultValue: 'Rewatch the Video'
  }
};

export default messages;
